export enum CardKing {
  Credit = 'Credit',
  Debit = 'Debit',
}
